import { Injectable } from '@angular/core';
import { Map } from '../../models/objects.model';
import { DataStoreService } from '../../core/services/data-store/data-store.service';
import { SignFileInfo } from '../document-signing/sign-file-info';
import { NotificationService } from '../notification/notification.service';

// TODO MK-REF
@Injectable()
export class CustomService {
  constructor(
    private storeService: DataStoreService,
    private notifier: NotificationService) {}

  public fillZSIN(values: Map): void {
    for (const value in values) {
      if (values.hasOwnProperty(value)) {
        values[value] = this.fillField(value, values);
        if (value.indexOf('ZAWIADOMIENIA-DATA_AKTUALNEGO_STATUSU') > -1) {
          const d = new Date();
          values[value] = d;
        }
      }
    }
  }

  public getSignFileInfo(values: Map): SignFileInfo{
    const signFileInfo = new SignFileInfo();
    for (const value in values) {
      if (values.hasOwnProperty(value)) {
        if (value.indexOf('ZAWIADOMIENIA-IDENTYFIKATOR_ZMIANY') > -1) {
          if (!values[value] && this.getType().indexOf('Not2') < 0){
            this.notifier.error('Brak uzupełnionego identyfikatora zmiany.');
            return null;
          }
          signFileInfo.changeIdentifier = values[value];
          signFileInfo.sequenceNumber = '1';
          return signFileInfo;
        }        
      }
    }    
    return null;
  }

  private fillField(id: string, values: Map): any {
    /*
    if (id.indexOf('ZAWIADOMIENIA-KOD_ADRESATA') > -1) {
      return this.getReceiver();
    }
    */
    if (id.indexOf('ZAWIADOMIENIA-KOD_NADAWCY') > -1) {
      return this.getSender();
    }
    if (id.indexOf('ZAWIADOMIENIA-TYTUL') > -1) {
      return 'Zawiadomienie ' + this.storeService.currentObjectId;
    }
    if (id.indexOf('ZAWIADOMIENIA-TYP') > -1) {
      return this.getType();
    }
    if (id.indexOf('ZAWIADOMIENIA-STATUS') > -1) {
      return 'PrzyjeteDoObslugi';
    }
    // if (s.indexOf('ZAWIADOMIENIA-DATA_AKTUALNEGO_STATUSU') > -1) {
    //     const d = new Date();
    //     return d;
    // }
    if (id.indexOf('ZAWIADOMIENIA-CZY_POBRANO_DATE_STATUSU_2') > -1) {
      return 0;
    }
    if (id.indexOf('ZAWIADOMIENIA-CZY_POBRANO_DATE_STATUSU_3') > -1) {
      return 0;
    }
    // if (s.indexOf('ZAWIADOMIENIA-ID') > -1) {
    //     return 1;
    // }
    return values[id];
  }

  private getReceiver(): string {
    const id = this.storeService.currentElementId;

    if (id.indexOf('EGIB-ZSIN') > -1) {
      return 'ZSIN';
    }

    if (id.indexOf('EGIB-NKW') > -1) {
      return 'NKW';
    }

    if (id.indexOf('EGIB-OP') > -1) {
      return 'OP';
    }

    if (id.indexOf('NKW-EGIB') > -1) {
      return 'EGIB';
    }

    if (id.indexOf('ZSIN-EGIB') > -1) {
      return 'EGIB';
    }

    if (id.indexOf('RCIWN-ZSIN') > -1) {
      return 'ZSIN';
    }

    if (id.indexOf('CBDOZ-EGIB') > -1) {
      return 'EGIB';
    }

    if (id.indexOf('NOT-EGIB') > -1) {
      return 'EGIB';
    }

    return 'ZSIN';
  }

  private getSender(): string {
    const id = this.storeService.currentElementId;

    if (id.indexOf('EGIB-ZSIN') > -1) {
      return 'EGIB';
    }

    if (id.indexOf('EGIB-NKW') > -1) {
      return 'EGIB';
    }

    if (id.indexOf('EGIB-OP') > -1) {
      return 'EGIB';
    }

    if (id.indexOf('NKW-EGIB') > -1) {
      return 'NKW';
    }

    if (id.indexOf('ZSIN-EGIB') > -1) {
      return 'ZSIN';
    }

    if (id.indexOf('RCIWN-ZSIN') > -1) {
      return 'RCIWN';
    }

    if (id.indexOf('CBDOZ-EGIB') > -1) {
      return 'CBDOZ';
    }

    if (id.indexOf('NOT-EGIB') > -1) {
      return 'NOT';
    }

    return 'ZSIN';
  }

  public getType(): string {
    const id = this.storeService.currentElementId;
    return this.getTypeById(id);
  }

  getTypeById(id: string): string {
    if (id.indexOf('EGIB-ZSIN') > -1) {
      return 'Egib2Zsin';
    }

    if (id.indexOf('EGIB-NKW') > -1) {
      return 'Egib2Nkw';
    }

    if (id.indexOf('EGIB-OP') > -1) {
      return 'Egib2Op';
    }

    if (id.indexOf('NKW-EGIB') > -1) {
      return 'Nkw2Egib';
    }

    if (id.indexOf('ZSIN-EGIB') > -1) {
      return 'Zsin2Egib';
    }

    if (id.indexOf('RCIWN-ZSIN') > -1) {
      return 'Rciwn2Zsin';
    }

    if (id.indexOf('EGIB-CBDOZ') > -1) {
      return 'Egib2Cbdoz';
    }

    if (id.indexOf('CBDOZ-EGIB') > -1) {
      return 'Cbdoz2Egib';
    }

    if (id.indexOf('CBDOZ-ZSIN') > -1) {
      return 'Cbdoz2Zsin';
    }

    if (id.indexOf('CRFOP-EGIB') > -1) {
      return 'Crfop2Egib';
    }

    if (id.indexOf('EMUIA-EGIB') > -1) {
      return 'Emuia2Egib';
    }

    if (id.indexOf('EMUIA-GUS') > -1) {
      return 'Emuia2Teryt';
    }

    if (id.indexOf('NOT-EGIB') > -1) {
      return 'Not2Egib';
    }

    if (id.indexOf('NOT-US') > -1) {
      return 'Not2Us';
    }

    if (id.indexOf('WYPIS-EGIB') > -1) {
      return 'Wypis2Egib';
    }

    return 'Egib2Zsin';
  }

  isSender(id: string): boolean {
    const senders: string[] = ['EGIB2ZSIN', 'EGIB2NKW', 'EGIB2OP', 'RCIWN2ZSIN'];
    const pom: string = this.getTypeById(id).toUpperCase();
    if (senders.includes(this.getTypeById(id).toUpperCase())) return true;
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/custom/custom.service.ts